import React from "react";
import { Menu, MenuItem, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { ChevronDown } from "lucide-react";

type Option = {
  value: string;
  label: string;
  image: string;
  url: string;
};

interface Props {
  options: Record<string, Option>;
  selectedOption: Option;
}

const CountryFooterSelector = ({ options, selectedOption }: Props) => {
  const otherOptions = Object.values(options).filter((o) => o.value !== selectedOption.value);
  return (
    <Menu
      menuPlacement="top-end"
      ButtonProps={{
        variant: ButtonVariant.IconShadowHidden,
        className: "p-0 hover:bg-transparent",
        children: (
          <span className="inline-flex items-center gap-2 text-base font-normal">
            <img src={selectedOption.image} alt="" className="w-4 h-4 rounded-full" />
            {selectedOption.label}
            <ChevronDown size={16} className="text-gray-50" />
          </span>
        ),
      }}
    >
      {otherOptions.map((o) => (
        <MenuItem
          key={o.value}
          onClick={() => {
            window.location.href = o.url;
          }}
        >
          <span className="inline-flex items-center gap-2 text-base font-normal">
            <img src={o.image} alt="" className="w-4 h-4 rounded-full" />
            {o.label}
          </span>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default CountryFooterSelector;
